import { DEFAULT_BOOK } from "./constants"

/**
 * Object containing the available application modes and their corresponding labels.
 */
export const SELECT_CORRECT_WORD_BOOKS = {
  amerika: "amerika",
  [DEFAULT_BOOK]: DEFAULT_BOOK,
  prozess: "prozess",
  urtail: "urtail",
} as const

export type SelectCorrectWordBook = keyof typeof SELECT_CORRECT_WORD_BOOKS
